<template>
  <div :class="['basic-row-tab','basic-row-tab-style-'+pc_widgets_infor.moduleStyle,'basic-row-tab-position-'+pc_widgets_infor.tagPosition]" :style="componentStyle">
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="tab-nav-outer">
      <ul :class="['tab-nav','tab-nav-'+pc_widgets_infor.tagLayout]"
          :style="tabBarStyle">
        <template v-for="(tab, index) in listArr.tabs">
          <li
            :key="tab.id"
            :class="{'tab-item':true,'tab-item-active':index === module.currentIndex,}"
            :style="getTabItemStyle(tab, index)"
            @mouseenter="onMouseEnterTabItem(index)"
            @click="onClickTabItem(index)">
          <span class="name-text-wrapper">
            <!-- 图标这边 需要整体修改 -->
              <div class="name-icon-wrap" :class="[ icon_show ? `position-${listArr.icon_set.icon_positon}` : '']">
                <img :src="tab.icon_before" alt="" class="icon-img icon-before" v-if="icon_show" :style="{
                  width: listArr.icon_set.icon_width +'px'
                }">
                <img :src="tab.icon_hover" alt="" class="icon-img icon-hover" :style="{
                  width: listArr.icon_set.icon_width +'px'
                }" v-if="icon_show">
                <span class="tab-name-text">{{ tab.name }}</span>
              </div>
              
              <span v-if="hasSelectTagUnderlineSetting && infor.tagUnderlineSelect==='short'"
                    class="tab-item-underline tab-item-underline-short">
          </span>

        </span>
            <span v-if="hasSelectTagUnderlineSetting && infor.tagUnderlineSelect==='long'"
                  :class="`tab-item-underline tab-item-underline-${infor.tagUnderlineSelect}`"></span>
            <span v-if="hasSelectTagArrowSetting && infor.tagArrowSelect==='show'"
                  :style="arrowStyle"
                  class="tab-item-arrow"></span>
            <div
              v-if="isPC"
              class="tooptipPart operate-tooltip tag-edit-icon"
              @click.stop
            >
              <my_edit_btn :module="module" tabName="style" coverClick
                           @click.native="onClickEditBtn(tab)"></my_edit_btn>
            </div>
          </li>
          <span v-if="hasTagSplitLineSetting" :style="splitLineStyle" class="tab-item-split"></span>
        </template>
      </ul>
    </div>
    <div class="tab-content">
      <div class="tab-content-wrapper">
        <div v-for="(tab,index) in module.children" :key="tab.id" :data-index="index"
             :class="{'tab-panel':true,'tab-panel-active':index===module.currentIndex}" :data-id="module.widgetId">
          <layout_column
            :column="tab"
            :row="row"
            :row1="row1"
            :col_index="index"
            :key="tab.widgets_id"
          ></layout_column>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import layout_column from '../layout_column/index'
import basic_module from '../basic_module/index'

export default {
  name: "basic_row_tab_index",
  components: {
    layout_column,
    basic_module
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    row1: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr;
    },
    tabBarStyle() {
      let keys = [{
        key: 'barBorder',
        fn: this.$utils.getBorderStyle
      }]
      return this.getCustomStyle(keys)
    },
    componentStyle() {
      let keys = [{
        key: 'background',
        fn: this.$utils.getBackground
      }, {
        key: 'border',
        fn: this.$utils.getBorderStyle
      }, {
        key: 'boxShadow',
        fn: this.$utils.getBoxShadowStyle
      }]
      return this.getCustomStyle(keys)
    },
    splitLineStyle() {
      let splitLine = this.getInfoByKey('tagSplitLine')
      if (splitLine.radio_val === 'default') {
        if (this.pc_widgets_infor.moduleStyle === 5) {
          return {
            display: 'none'
          }
        } else {
          return {}
        }
      } else if (splitLine.radio_val === 'hidden') {
        return {
          display: 'none'
        }
      }
      let style = {}
      if (splitLine.custom.type === 'slash') {
        style.transform = 'skew(-14deg)'
      }
      style.background = splitLine.custom.color
      return style
    },
    arrowStyle() {
      let tagBackgroundSelect = this.getInfoByKey('tagBackgroundSelect')
      if (tagBackgroundSelect.radio_val === 'custom') {
        return {
          'border-top-color': tagBackgroundSelect[tagBackgroundSelect.radio_val].color
        }
      } else if (tagBackgroundSelect.radio_val === 'hidden') {
        return {
          'border-top-color': 'transparent'
        }
      }
    },
    hasSelectTagShadowSetting() {
      return [1, 2].includes(this.pc_widgets_infor.moduleStyle)
    },
    hasTagSplitLineSetting() {
      return [3, 4, 5].includes(this.pc_widgets_infor.moduleStyle)
    },
    hasSelectTagUnderlineSetting() {
      return this.pc_widgets_infor.moduleStyle === 3
    },
    hasSelectTagArrowSetting() {
      return this.pc_widgets_infor.moduleStyle === 5
    },
    icon_show() {
      return this.isPC && this.listArr.icon_set&& this.listArr.icon_set.icon_show =='true'
    }
  },
  watch: {
    'pc_widgets_infor.tabPanelHeight'() {
      this.resetPanelLayoutStyle()
    },
    'module.changeIndexTo'(index) {
      if (index === '') {
        return
      }
      if (index === this.module.currentIndex) {
        this.module.changeIndexTo = ''
        return
      }
      if (localStorage.getItem('needScrollToActiveTab')) {
        this.scrollToActiveTab(index)
        this.module.changeIndexTo = ''
        localStorage.setItem('needScrollToActiveTab', '')
      }
    }
  },
  methods: {
    add_attr() { // 4.9.0.4 这边新增了很多属性
      if (typeof this.listArr.icon_set == 'undefined') {
        this.listArr.tabs.forEach((item, index) => {
          if (!item.icon_before) this.$set(this.listArr.tabs[index], 'icon_before', 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png' )
          if (!item.icon_hover) this.$set(this.listArr.tabs[index], 'icon_hover', 'https://sitecdn.71360.com/static/txys-001/image/icon_material/1/1_ (1).png')
        })
        let icon_set = {
          icon_show: 'false',
          icon_width: 20,
          icon_positon: 'left'
        }
        this.$set(this.listArr, 'icon_set', icon_set)
      }
     
     },
    onClickEditBtn(tab) {
      this.$store.commit("app/changeModuleSelectItemId", tab.id);
      localStorage.setItem('needAutoFocus', 'true')
      this.templet.changeStyle(this.module, 'style');
    },
    onMouseEnterTabItem(index) {
      if (this.pc_widgets_infor.triggerType !== 'hover') {
        return;
      }
      if (this.module.currentIndex === index) {
        return
      }
      this.scrollToActiveTab(index)
      this.panelModuleAnimate()
    },
    onClickTabItem(index) {
      if (this.pc_widgets_infor.triggerType !== 'click') {
        return;
      }
      if (this.module.currentIndex === index) {
        return
      }
      this.scrollToActiveTab(index)
      this.panelModuleAnimate()
    },
    scrollToActiveTab(index, option) {
      if (this.pc_widgets_infor.tabPanelHeight === 'group') {
        this.scrollToActiveTabGroupHeight(index, option)
      } else {
        this.scrollToActiveTabSingleHeight(index, option)
      }
    },
    scrollToActiveTabGroupHeight(index, option = {}) {
      // 这里的动画本来用的transform: translateX, 但是transform会影响里面嵌套组件的position:fixed，所以改成left
      this.handleTabAnimateOverflow()
      let noAnimate = option.noAnimate
      if (noAnimate) {
        let $content = this.$wrapper.find('.tab-content')
        $content.addClass('tab-content-no-animate')
        setTimeout(() => {
          $content.removeClass('tab-content-no-animate')
        }, 600)
      }
      let $currentPanel = this.$wrapper.find('.tab-panel').eq(index)

      // prevAll 返回元素的顺序是按离目标元素的距离从近到远,所以要reverse一下
      $($currentPanel.prevAll().get().reverse()).each((i, item) => {
        $(item).stop().animate({
          left: (-100 * (i + 1) - 5) + '%' // 轮播多图组件很诡异地会有几像素隐藏不掉，所以多移5%
        })
      })
      $currentPanel.stop().animate({
        left: (-100 * (index)) + '%'
      })
      $currentPanel.nextAll().each((i, item) => {
        $(item).stop().animate({
          left: ((-100 * i) + 5) + '%' // 轮播多图组件很诡异地会有几像素隐藏不掉，所以多移5%
        })
      })
      this.module.currentIndex = index
    },
    scrollToActiveTabSingleHeight(index, option = {}) {
      this.handleTabAnimateOverflow()
      let $panels = this.$wrapper.find('.tab-panel')
      let $currentPanel = $panels.eq(index)
      $panels.css({
        position: 'absolute'
      })
      $currentPanel.css({
        position: 'relative'
      })
      let noAnimate = option.noAnimate
      if (noAnimate) {
        $currentPanel.prevAll().each((i, item) => {
          $(item).css({
            left: '-100%'
          })
        })
        $currentPanel.css({
          left: '0'
        })
        $currentPanel.nextAll().each((i, item) => {
          $(item).css({
            left: '100%'
          })
        })
      } else {
        $currentPanel.prevAll().each((i, item) => {
          $(item).stop().animate({
            left: '-100%'
          })
        })
        $currentPanel.stop().animate({
          left: '0'
        })
        $currentPanel.nextAll().each((i, item) => {
          $(item).stop().animate({
            left: '100%'
          })
        })
      }
      this.module.currentIndex = index
    },
    resetPanelLayoutStyle(option = {}) {
      let $panels = this.$wrapper.find('.tab-panel')
      if (this.pc_widgets_infor.tabPanelHeight === 'group') {
        $panels.css({
          position: 'relative',
          left: 0
        })
        this.scrollToActiveTab(this.module.currentIndex, option)
      } else {
        $panels.css({
          position: 'absolute',
          transform: 'none'
        })
        $panels.eq(this.module.currentIndex).css({
          position: 'relative',
        })
        this.scrollToActiveTab(this.module.currentIndex, option)
      }
    },
    getTabItemStyle(tab, index) {
      if (index === this.module.currentIndex) {
        let keys = [{
          key: 'tagFontSelect',
          fn: this.$utils.getFontStyle
        }, {
          key: 'tagBackgroundSelect',
          fn: this.$utils.getBackground
        }, {
          key: 'tagBorderSelect',
          fn: this.$utils.getBorderStyle
        }, {
          key: 'tagMargin',
          fn: this.$utils.getHalfMarginStyle
        }, {
          key: 'tagBorderRadius',
          fn: this.$utils.getBorderRadiusStyle
        }]
        let style = this.getCustomStyle(keys)
        if (this.hasSelectTagShadowSetting && this.infor.tagHasShadowSelect === 'true') {
          let background = this.getInfoByKey('tagBackgroundSelect')
          if (background.radio_val !== 'hidden') {
            style.boxShadow = `0px 3px 9px -1px ${background[background.radio_val].color}`
          }
        }
        return style
      } else {
        let keys = [{
          key: 'tagFont',
          fn: this.$utils.getFontStyle
        }, {
          key: 'tagBackground',
          fn: this.$utils.getBackground
        }, {
          key: 'tagBorder',
          fn: this.$utils.getBorderStyle
        }, {
          key: 'tagMargin',
          fn: this.$utils.getHalfMarginStyle
        }, {
          key: 'tagBorderRadius',
          fn: this.$utils.getBorderRadiusStyle
        }]
        return this.getCustomStyle(keys)
      }
    },
    getInfoByKey(key) {
      if (this.isPC || this.mb_widgets_infor[key].radio_val === 'default') {
        return this.pc_widgets_infor[key]
      } else {
        return this.mb_widgets_infor[key]
      }
    },
    getCustomStyle(keys) {
      let style = {}
      keys.forEach(key => {
        let infoData = this.getInfoByKey(key.key)
        if (infoData.radio_val !== 'default') {
          style = Object.assign(style, key.fn(infoData))
        }
      })
      return style
    },
    panelModuleAnimate() {
      setTimeout(() => {
        const implement = this.$store.state.moduleAnimation.implement;
        for (let i = 0; i < implement.length; i++) {
          const id = implement[i].module.widgets_id;
          const dom = document.querySelector(
            '[data-animation-key="j-' + id + '"]'
          );
          //如果是在横幅中的
          if ($(dom).parents(".full_screen_banner").length > 0) {
            //只有当前选中的横幅
            if (
              $(dom).parents(".swiper-slide").hasClass(".swiper-slide-active")
            ) {
              implement[i].vue.animation(dom);
            }
          } else {
            implement[i].vue.animation(dom);
          }
        }
      }, 500)
    },
    mobileHorizontalDrag() {
      let drag = function (el) {
        let $el = $(el)
        $el.bind('mousedown', start)
        let gapX
        let startX

        function start(event) {
          if (event.button === 0) {        // 判断是否点击鼠标左键
            gapX = event.clientX
            startX = $($el).scrollLeft()   // scroll的初始位置


            $(document).bind('mousemove', move)    // movemove事件必须绑定到$(document)上，鼠标移动是在整个屏幕上的
            $(document).bind('mouseup', stop)      // 此处的$(document)可以改为obj
          }
          return false;  // 阻止默认事件或冒泡
        }

        function move(event) {
          let left = event.clientX - gapX     // 鼠标移动的相对距离
          $($el).scrollLeft(startX - left)
          return false                        // 阻止默认事件或冒泡
        }

        function stop() {
          $(document).unbind('mousemove', move)
          $(document).unbind('mouseup', stop)
        }
      }
      let el = this.$wrapper.find('.tab-nav-outer');
      drag(el);
    },
    handleTabAnimateOverflow() {
      this.$wrapper.find('.tab-content-wrapper').css({
        overflow: 'hidden'
      })
      this.$wrapper.find('.tab-panel').css({
        opacity: 1,
        visibility: 'visible',
      })
      clearTimeout(this.timmer)

      this.timmer = setTimeout(() => {
        let $currentPanel = this.$wrapper.find('.tab-panel').eq(this.module.currentIndex)
        $currentPanel.siblings().css({
          opacity: 0,
          visibility: 'hidden'
        })
        this.$wrapper.find('.tab-content-wrapper').css({
          overflow: 'visible'
        })
      }, 600)
    }
  },
  created() {
    if (this.module.currentIndex === undefined) {
      this.$set(this.module, 'currentIndex', 0)
      this.$set(this.module, 'changeIndexTo', '')
    }

    if (typeof this.pc_widgets_infor.tagPosition === 'undefined') {
      this.$set(this.pc_widgets_infor, 'tagPosition', 'top')
    }

    this.timmer = null
  },
  mounted() {
    this.$wrapper = $('#u' + this.module.widgets_id)
    this.resetPanelLayoutStyle({noAnimate: true})
    this.mobileHorizontalDrag()
    this.add_attr()
  }
}
</script>

<style lang="scss" scoped>
.pc_pattern{
  .tab-item{
    max-width: 100%;
    .name-text-wrapper{
      .name-icon-wrap{
        &.position-left,&.position-right,&.position-top,&.position-bottom{
          display: flex;
          justify-content: center;
          .icon-img {
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
            &.icon-hover{
              display:none;
            }
          }
          // icon-before
        }
        &.position-left,&.position-right{
          flex-direction: row;
          align-items: center;
        }
        &.position-top,&.position-bottom{
          flex-direction: column;
          align-items: center;
          .tab-name-text{
            max-width: 100%;
          }
        }
        &.position-left{
          .icon-img{
            margin-right:16px;
          }
        }
        &.position-right{
          flex-direction: row-reverse;
          .icon-img{
            margin-left:16px;
          }
        }
        &.position-top{
          .icon-img{
            margin-bottom:16px;
          }
        }
        &.position-bottom{
          flex-direction: column-reverse;
          .icon-img{
            margin-top:16px;
          }
        }
      }
    }
  }
  .tab-item-active{
    .name-text-wrapper{
      .name-icon-wrap{
        &.position-left,&.position-right,&.position-top,&.position-bottom{
          .icon-img {
            &.icon-before{
              display:none;
            }
            &.icon-hover{
              display:block;
            }
          }
        }
       
      }
    }
  }
}
.basic-row-tab {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  display: flex;
  flex-direction: column;
}

.basic-row-tab-position-top {
  .tab-nav-outer {
    order: 1;
  }
  .tab-content {
    order: 2;
  }
}

.basic-row-tab-position-bottom {
  .tab-nav-outer {
    order: 2;
  }
  .tab-content {
    order: 1;
  }
}

.tab-nav-outer {
  overflow-x: auto;
  overflow-y: visible;
}

.tab-nav {
  display: flex;
  flex-wrap: wrap;
  overflow-y: visible;
}

.mb_pattern .tab-nav {
  flex-wrap: nowrap;
  overflow-x: auto;
  width: min-content;
  position: relative;
}
.mb_pattern {
  .tab-nav-stretch{
    min-width: 100%;
  }
}

.basic_row_tab .tab-nav-outer::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.tab-nav-center {
  justify-content: center;
}

.tab-nav-right {
  justify-content: flex-end;
}

.tab-nav-stretch .tab-item {
  //flex: 1;
  flex-grow: 1;
}


.tab-item {
  font-size: 14px;
  color: #202020;
  box-sizing: border-box;
  padding: 10px 20px;
  margin: 10px 5px;
  // max-width: 360px;
  // min-width: 54px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  .name-text-wrapper {
    width: 100%;
  }

  .tab-name-text {
    display: block;
    // width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.tag-edit-icon.tooptipPart.operate-tooltip {
  display: none;
}

.tab-item:hover {
  .tag-edit-icon.tooptipPart.operate-tooltip {
    display: block;
  }
}

// 模块样式
.basic-row-tab-style-1 .tab-item {
  border: 1px solid #f0f0f0;
  border-radius: 2px;

  &.tab-item-active {
    background-color: var(--theme_color);
    color: #fff;
    border-color: transparent;
  }
}

.basic-row-tab-style-2 .tab-item {
  border-radius: 16px;
  padding: 10px 20px;

  &.tab-item-active {
    background-color: var(--theme_color);
    color: #fff;
  }
}

.basic-row-tab-style-3 .tab-nav {
  border-bottom: 1px solid #e6e6e6;
}

.basic-row-tab-style-3, .basic-row-tab-style-4, .basic-row-tab-style-5 {
  .tab-item:first-child {
    .tab-item-split {
      display: none;
    }
  }

  .tab-item-split {
    width: 1px;
    height: 16px;
    background: #dcdcdc;
    left: -5px;
    align-self: center;
    flex-shrink: 0;

    &:last-child {
      visibility: hidden;
    }
  }
}

.basic-row-tab-style-3 .tab-item {
  margin: 0 5px;
  padding: 10px 20px;

  .name-text-wrapper {
    position: relative;
  }

  .tab-item-underline {
    display: none;
  }

  &.tab-item-active {
    color: var(--theme_color);

    .tab-item-underline {
      display: block;
      height: 2px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: var(--theme_color);
    }

    .tab-item-underline-short {
      width: calc(100% - 10px);
      left: 50%;
      transform: translateX(-50%);
      bottom: -16px;
    }

    .tab-item-underline-hidden {
      display: none;
    }
  }

}

.basic-row-tab-style-4 .tab-item {
  margin: 0 5px;
  padding: 10px 20px;

  &.tab-item-active {
    color: var(--theme_color);
  }
}

.basic-row-tab-style-5 .tab-item {
  border-radius: 2px;
  padding: 10px 20px;

  &.tab-item-active {
    background-color: var(--theme_color);
    color: #fff;
  }
}

.basic-row-tab-style-5 .tab-item-arrow {
  display: none;
}

.basic-row-tab-style-5 .tab-item-active {
  .tab-item-arrow {
    display: block;
    width: 0;
    height: 0;
    z-index: 1;
    transform-origin: 50% 25%;
    bottom: -12px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent;
    border-top-color: var(--theme_color);
  }
}

.basic-row-tab-style-6 .tab-nav {
  background: #2b2b2b;
}

.basic-row-tab-style-6 .tab-item {
  margin: 0 5px;
  color: #fff;
  padding: 15px 20px;
  background-color: transparent;

  &:first-child {
    margin-left: 0;
  }
  &:last-child{
    margin-right:0;
  }
}

.basic-row-tab-style-6 .tab-item-active {
  background: var(--theme_color);
}

.tab-content {
  padding: 0 10px 10px;

  .tab-content-wrapper {
    white-space: nowrap;
    //overflow: hidden;
    position: relative;
  }

  .tab-panel {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    min-height: 100px;
    transition: transform 0.5s;
    position: relative;
    white-space: initial;
  }

  &.tab-content-no-animate .tab-panel {
    transition: transform 0s;
  }

  .modules.sort_modules.tab-panel {
    float: none;
  }
}

.tab-item {
  position: relative;

  .operate-tooltip {
    position: absolute;
    top: auto;
    left: auto;
    right: 0;
    bottom: 0;
  }

  &:hover .operate-tooltip {
    display: block;
  }
}

</style>
<style>
.pc_pattern .basic-row-tab .tab-content .no_module {
  height: 150px;
}

.basic_row_tab.module .line_frame {
  display: none;
}

.basic_row_tab.module:hover > .line_frame {
  display: block;
}

.basic_row_tab .tab-content .module:hover > .line_frame {
  display: block;
}

.basic_row_tab.module .draggable_icon {
  display: none;
}

.basic_row_tab.module:hover > .draggable_icon {
  display: block;
}

.basic_row_tab .tab-content .module:hover > .draggable_icon {
  display: block;
}

.pc_pattern .module .basic-row-tab .module .tooptipPart {
  display: none;
}

.pc_pattern .module .basic-row-tab .module:hover .tooptipPart {
  display: block;
}

.pc_pattern .module .basic-row-tab .all_tooptipPart {
  display: none;
}

.pc_pattern .module .basic-row-tab .module:hover .all_tooptipPart {
  display: block;
}

.material-agent {
  /*background: pink !important;*/
}

.layrow .laybox .one_column .modules .module_placeholder:before {
  /*min-height: 50px;*/
}

.layrow .laybox .modules .module_placeholder.module_placeholder_disable {
  border: 1px #fd345d dashed;
}


.layrow .laybox .one_column .modules .module_placeholder.module_placeholder_disable:before {
  content: '不支持添加该模块';
  color: #fd345d;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_row_tab/index.vue